<!-- src/app/pages/expediente/expediente-digital/sections/paraclinicos/paraclinicos-page/components/analizador-laboratorio/analizador-laboratorio.component.html -->

<ion-modal [isOpen]="isOpen" (didDismiss)="close()">
  <ng-template>
    <ion-header>
      <ion-toolbar>
        <ion-title>Analizando Laboratorio</ion-title>
        <ion-buttons slot="end">
          <ion-button (click)="close()">
            <ion-icon name="close"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>

    <ion-content class="ion-padding">
      <!-- Estado: Extrayendo -->
      <div *ngIf="estado === 'extrayendo' || estado === 'parseando'" class="text-center py-8">
        <ion-spinner color="primary" class="w-16 h-16"></ion-spinner>

        <h3 class="text-lg font-semibold mt-4 text-gray-800">
          {{ estado === 'extrayendo' ? 'Extrayendo datos del PDF...' : 'Analizando parámetros...' }}
        </h3>

        <p class="text-sm text-gray-600 mt-2">
          {{ mensajeEstado }}
        </p>

        <!-- Barra de progreso -->
        <div class="w-full bg-gray-200 rounded-full h-2 mt-4 max-w-md mx-auto">
          <div class="bg-[#AE91E3] h-2 rounded-full transition-all duration-300" [style.width.%]="progreso"></div>
        </div>

        <p class="text-xs text-gray-500 mt-2">{{ progreso }}%</p>
      </div>

      <!-- Estado: Mostrando resultados -->
      <div *ngIf="estado === 'mostrando'" class="py-4">
        <div class="flex items-center justify-center mb-4">
          <ion-icon name="checkmark-circle" class="text-green-500 text-5xl"></ion-icon>
        </div>

        <h3 class="text-xl font-bold text-center text-gray-800 mb-2">Análisis Completado</h3>

        <p class="text-center text-gray-600 mb-6">
          Se encontraron <strong>{{ resultados.length }} parámetros</strong> en el PDF
        </p>

        <!-- Resumen de resultados -->
        <div class="bg-gray-50 rounded-lg p-4 mb-4">
          <h4 class="font-semibold text-gray-700 mb-3">Resumen:</h4>

          <div class="space-y-2">
            <div class="flex justify-between text-sm">
              <span class="text-gray-600">Parámetros extraídos:</span>
              <span class="font-semibold">{{ resultados.length }}</span>
            </div>

            <div class="flex justify-between text-sm">
              <span class="text-gray-600">Valores fuera de rango:</span>
              <span class="font-semibold text-red-600">
                {{ getCountFueraRango() }}
              </span>
            </div>

            <div class="flex justify-between text-sm">
              <span class="text-gray-600">Confianza promedio:</span>
              <span class="font-semibold">{{ calcularConfianzaPromedio() }}%</span>
            </div>
          </div>
        </div>

        <ion-button expand="block" color="primary" (click)="close()"> Ver Resultados </ion-button>
      </div>

      <!-- Estado: Error -->
      <div *ngIf="estado === 'error'" class="text-center py-8">
        <ion-icon name="alert-circle" class="text-red-500 text-5xl mb-4"></ion-icon>

        <h3 class="text-lg font-semibold text-gray-800 mb-2">Error al Analizar PDF</h3>

        <p class="text-sm text-gray-600 mb-6">
          {{ errorMensaje }}
        </p>

        <div class="flex gap-3 justify-center">
          <ion-button fill="outline" (click)="close()"> Cancelar </ion-button>
          <ion-button (click)="reintentar()"> Reintentar </ion-button>
        </div>
      </div>
    </ion-content>
  </ng-template>
</ion-modal>
